module.exports = __webpack_public_path__ + "static/media/marcado.4cc32e28.svg";